import { TitleResponse } from 'src/modules/member/models/titleResponse';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'title';

export const getAllTitles = (type: number | null) => {
  const endpoint = `${controller}${type ? `?type=${type}` : ''}`;
  return AxiosInstance.get<PagedResult<TitleResponse>>(endpoint);
};
